<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-1 text-primary font-weight-bold">Guest Book</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Formulir Buku Tamu</b>
          <br />
          <br />
          <br />
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Guest Book Receiver"
                label-for="input-1"
              >
                <input
                  v-model="items.receiver_email"
                  v-validate="'required'"
                  name="receiver_email"
                  data-vv-as="Receiver Email"
                  placeholder="Receiver Email"
                  class="form-control"
                />
                <b-form-invalid-feedback id="input-receiver_email-feedback">{{
                  veeErrors.first("receiver_email")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="White paper document (In Bahasa)"
                label-for="input-1"
              >
                <input
                  v-model="items.white_paper_url_id"
                  v-validate="'required'"
                  name="white_paper_url_id"
                  data-vv-as="White paper document Bahasa"
                  placeholder="White paper document Bahasa"
                  class="form-control"
                />
                <b-form-invalid-feedback
                  id="input-white_paper_url_id-feedback"
                  >{{
                    veeErrors.first("white_paper_url_id")
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="White paper document (In English)"
                label-for="input-1"
              >
                <input
                  v-model="items.white_paper_url_en"
                  v-validate="'required'"
                  name="white_paper_url_en"
                  data-vv-as="White paper document English"
                  placeholder="White paper document English"
                  class="form-control"
                />
                <b-form-invalid-feedback
                  id="input-white_paper_url_en-feedback"
                  >{{
                    veeErrors.first("white_paper_url_en")
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>
          <!-- <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image URL WebP (Desktop):"
            label-for="input-1"
          >
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Banner Image (Desktop)</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(1920px x 700px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="fileDesktop"
                      name="image_desktop_jpg"
                      v-validate="
                        'minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,gif,jpeg,webp'
                      "
                      style="display: none"
                      v-on:change="onChangeFileDesktop()"
                    />
                    <b-button
                      @click="$refs.fileDesktop.click()"
                      v-show="!items.image_desktop_jpg && !fileDesktop"
                      variant="primary"
                      class="ml-5"
                      >Select File</b-button
                    >
                    <b-button
                      v-show="items.image_desktop_jpg || fileDesktop"
                      variant="primary"
                      @click="modalDesktop = !modalDesktop"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.fileDesktop.click()"
                      v-show="items.image_desktop_jpg || fileDesktop"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("imagedesktop") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image URL WebP (Mobile):"
            label-for="input-1"
          >
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Banner Image (Mobile)</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(640px x 600px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="fileMobile"
                      name="imagemobile"
                      v-validate="
                        'minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,gif,jpeg,webp'
                      "
                      style="display: none"
                      v-on:change="onChangeFileMobile()"
                    />
                    <b-button
                      @click="$refs.fileMobile.click()"
                      v-show="!items.image_mobile_jpg && !fileMobile"
                      variant="primary"
                      class="ml-5"
                      >Select File</b-button
                    >
                    <b-button
                      v-show="items.image_mobile_jpg || fileMobile"
                      variant="primary"
                      @click="modalMobile = !modalMobile"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.fileMobile.click()"
                      v-show="items.image_mobile_jpg || fileMobile"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("imagemobile") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row> -->
          <br />
          <!-- <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (Bahasa)"
            label-for="input-1"
          >
            <input
              v-model="items.header_id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Heading Bahasa"
              placeholder="Heading in Bahasa"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (English)"
            label-for="input-1"
          >
            <input
              v-model="items.header_en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Heading English"
              placeholder="Heading in English"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (Bahasa)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="items.sub_heading_id"
              tag-name="textarea"
              placeholder="Sub Heading Bahasa"
              v-validate="'required'"
              name="sub_title_id"
              data-vv-as="Sub Heading Bahasa"
              class="form-control"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("sub_title_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (English)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="items.sub_heading_en"
              tag-name="textarea"
              placeholder="Sub Heading English"
              v-validate="'required'"
              name="sub_title_en"
              data-vv-as="Sub Heading English"
              class="form-control"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("sub_title_en") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row> -->
          <br />
          <br />
          <!-- <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Period" label-for="input-1">
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-row class="m-0">
                <b-col
                  class="pr-0 pt-1 form-control img-calender-select border-right-0"
                  md="2"
                >
                  <img
                    src="@/assets/ic-calendar-copy-30.svg"
                    width="25px"
                    alt
                    class
                  />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="items.start_date"
                    :format="customFormatter"
                    :disabled="items.is_always_active"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row class="pt-1">
                      <b-col>
                        <b-link
                          @click="resetStardate"
                          style="text-decoration: none"
                        >
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col>
          <p class="mb-2">&nbsp;</p>
          <b-form-group id="fieldset-1" label-for="input-1">
            <b-row class="m-0">
              <b-col
                class="pr-0 pt-1 form-control img-calender-select border-right-0"
                md="2"
              >
                <img
                  src="@/assets/ic-calendar-copy-30.svg"
                  width="25px"
                  alt
                  class
                />
              </b-col>
              <b-col class="px-0">
                <datepicker
                  input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                  placeholder="Select Date"
                  v-model="items.end_date"
                  :format="customFormatter"
                  :disabled="items.is_always_active"
                  :disabledDates="disabledDates"
                ></datepicker>
              </b-col>
              <b-col align="left" md="1" class="px-0">
                <b-col
                  class="pt-1 px-4 form-control del-calender-select border-left-0"
                  md="2"
                >
                  <b-row class="pt-1">
                    <b-col>
                      <b-link
                        @click="resetEnddate"
                        style="text-decoration: none"
                      >
                        <i class="text-danger fas fa-times"></i>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row> -->
          <br />
          <br />
          <b-row>
            <b-col align="right">
              <b-button
                variant="primary"
                @click="put()"
                :disabled="loading"
                size="lg"
                class="mr-3"
                >Save</b-button
              >
              <!-- <router-link :to="{ name: 'bannerLocker' }">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link> -->
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <br />
  </div>
</template>

<script>
import _ from "lodash";
import Datepicker from "vuejs-datepicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  components: {
    Datepicker,
  },
  data() {
    return {
      editor: ClassicEditor,
      widthMobile: null,
      heightMobile: null,
      widthDesktop: null,
      heightDesktop: null,
      InputImageMobile: false,
      InputImageDesktop: false,
      modalMobile: false,
      modalDesktop: false,
      fileDesktop: "",
      fileMobile: "",
      urlMobile: "",
      urlDesktop: "",
      isLoadingArticle: false,
      searchTermArticle: "",
      modalPlayStore: false,
      modalAppStore: false,
      play_store_icon: "",
      play_store_url: "",
      app_store_icon: "",
      app_store_url: "",
      urlAppStore: "",
      urlPlayStore: "",
      dataArticle: [],
      items: [],
      options: [],
      options1: [
        { text: "No", value: false },
        { text: "Yes", value: true },
      ],
      options3: [
        { text: "Article", value: true },
        { text: "Other URL", value: false },
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },
  beforeCreate() {
    this.$store.dispatch("guestBookModule/getGuestBook");
  },
  created() {
    this.$store.watch(
      (state) => state.guestBookModule.guest_book,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Guest Book Settings!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("receiver_email", this.items.receiver_email);
              formData.append(
                "white_paper_url_id",
                this.items.white_paper_url_id
              );
              formData.append(
                "white_paper_url_en",
                this.items.white_paper_url_en
              );
              this.$store
                .dispatch("guestBookModule/postGuestBook", formData)
                .then((response) => {
                  this.loading = false;
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileAppStore() {
      this.app_store_icon = this.$refs.app_store_icon.files[0];
      const input = this.$refs.app_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlAppStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFilePlayStore() {
      this.play_store_icon = this.$refs.play_store_icon.files[0];
      const input = this.$refs.play_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPlayStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
